<template>
  <div id="coupon-carousel-single">
    <div class="coupon-carousel-inner" v-if="coupons.length > 0">
      <swiper
        :options="swiperOptions"
        navigation="true"
        :modules="modules"
        ref="couponCarouselSingle"
        @click="testEmit"
      >
        <swiper-slide v-for="(coupon, index) in coupons" :key="index">
          <img :src="coupon.remote_image" class="img-fluid" />
        </swiper-slide>
        <template v-slot:button-prev>
          <div
            class="swiper-button-prev"
            @click="$refs.couponCarouselSingle.swiperInstance.slidePrev()"
          ></div>
        </template>
        <template v-slot:button-next>
          <div
            class="swiper-button-next"
            @click="$refs.couponCarouselSingle.swiperInstance.slideNext()"
          ></div>
        </template>
      </swiper>
    </div>
  </div>
</template>
<!-- @TODO - May need to split functionality here as PPC doesn't technically support Vue Bootstrap -->
<script>
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data: () => {
    return {
      currentSlide: 0,
      modules: [Navigation],
      swiperOptions: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
          //waitForTransition: false
        },
        draggable: true,
        loop: true,
        slidesPerView: 1,
        edgeSwipeDetection: true,
        observer: true,
        observeParents: true,
      },
    };
  },
  props: {
    coupons: Array,
    selectedSlide: Number,
  },
  created() {},
  mounted: function () {
    const vm = this;
    //@TODO - Says swiperInstance isn't accessible, let's attempt to switch down below to computed version
    this.$nextTick(() => {
      if (vm.swiper !== undefined) {
        //vm.swiper.updateSize();
        vm.swiper.update();

        if (vm.selectedSlide > 0) {
          vm.swiper.slideTo(vm.selectedSlide + 1);
          /*
          if(this.$refs.couponCarouselSingle.swiperInstance.mounted){
            this.$refs.couponCarouselSingle.swiperInstance.slideTo(this.selectedSlide+1,1000,false);
          }
          */
        }
      }
    });
  },
  computed: {
    promotion() {
      return this.$store.state.promotion;
    },
    swiper() {
      return this.$refs.couponCarouselSingle.$swiper;
    },
  },
  methods: {
    selectCoupon(index) {
      this.$emit("couponClicked", index);
    },
    testEmit(e) {
      if (e.clickedSlide !== undefined) {
        if (e.clickedSlide.dataset.swiperSlideIndex !== undefined) {
          this.$emit("couponClicked", e.clickedSlide.dataset.swiperSlideIndex);
        } else {
          this.$emit("couponClicked", 0);
        }
      }
    },
  },
};
</script>

<style scoped>
.coupon-image:hover {
  cursor: pointer;
}
.swiper-slide {
  text-align: center;
}
.swiper-container {
  width: 100%;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 25px;
}
.swiper-button-prev,
.swiper-button-next {
  background: black;
  border-radius: 200%;
  width: 50px;
  height: 50px;
  color: white;
}
.swiper-button-prev.disabled {
  background: #f3f3f3;
}
.swiper-button-prev {
  left: 0px;
}
.swiper-button-next {
  right: 0px;
}
.swiper-button-next.ajax-spinner {
  visibility: hidden !important;
}
.ajax-spinner {
  position: absolute;
  right: 0;
  margin-right: 15px;
  z-index: 999;
  width: 50px;
  height: 50px;
  margin-top: 4px;
}
@media (max-width: 410px) {
  .swiper-slide-active,
  .swiper-slide-next {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
.appt-date .error-message {
  color: red;
}
</style>
